import React from "react";
import { contact } from "../../../components/ContactPage/contact";
import Layout from "../../../components/layout/layout";

export default function ContactPage({ component, ...rest }) {
  return <Layout Component={contact} controlsDisabled={true} {...rest} />;
}
